import {
  DataTableProps,
  SortableTableProps,
  SimplePaginationProps,
  TableStyleProps,
} from '@dixa/lib-shared-habla';
import type {
  SearchConversationEnriched,
  SearchSortField,
} from 'lib-search-types';
import { AsyncStatus } from 'lib-shared-types-api';

export type ConversationsTableProps = {
  conversations: readonly SearchConversationEnriched[];
  asyncStatus: AsyncStatus;
  selectableRowsProps?: DataTableProps<
    SearchConversationEnriched,
    never
  >['selectableRowsProps'];
  paginationProps?: SimplePaginationProps;
  sortingProps?: SortableTableProps;
  /** When provided, replaces the default navigation on row click. */
  onRowClick?: (conversation: SearchConversationEnriched) => void;
} & TableStyleProps;

export type ConversationsTableSortableField =
  (typeof conversationsTableSortableFields)[number];

export const conversationsTableSortableFields = [
  'created_at',
  'last_message_created_at',
] satisfies SearchSortField<'conversations'>[];
